import styled from 'styled-components';

const Panel = styled.div`
	position: absolute;
	bottom: 140px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	user-select: none;

	> div {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		gap: 20px;
	}
`;

export { Panel };
